module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-spinner"
  }, [_c('mt-cell-group', [_c('mt-cell', {
    attrs: {
      "title": "默认:snake+grey-lv5+28"
    }
  }, [_c('mt-spinner')], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "snake"
    }
  }, [_c('mt-spinner', {
    attrs: {
      "color": "#F26666",
      "type": "snake"
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "double-bounce"
    }
  }, [_c('mt-spinner', {
    attrs: {
      "color": "#FF7949",
      "type": "double-bounce",
      "size": 30
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "triple-bounce"
    }
  }, [_c('mt-spinner', {
    attrs: {
      "color": "#FFB950",
      "type": "triple-bounce",
      "size": 20
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "fading-circle"
    }
  }, [_c('mt-spinner', {
    attrs: {
      "color": "#A2D06B",
      "type": "fading-circle"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3300a2d6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/spinner.vue
// module id = 612
// module chunks = 0